var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeePartner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 140,
    viewBox: "0 0 280 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H268C274.351 0.5 279.5 5.64873 279.5 12V128C279.5 134.351 274.351 139.5 268 139.5H12C5.64873 139.5 0.5 134.351 0.5 128V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_2910_4691)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H268C274.351 0.5 279.5 5.64873 279.5 12V128C279.5 134.351 274.351 139.5 268 139.5H12C5.64873 139.5 0.5 134.351 0.5 128V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_2910_4691)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.837 77.5511V63.9353H105.273V62.4473H116.236V63.9353H111.672V77.5511H109.837Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.172 77.1039L116.429 62H118.415L123.244 75.1825L128.111 62H130.055L124.313 77.1039H122.172Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.473 54.9102H97.2596H80.6521V55.61V55.9585H95.6266L80.0659 85.0887H85.2788H101.887V84.3888V84.0382H86.9125L102.473 54.9102Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.857 40V100",
    stroke: "#BBBBBB",
    strokeWidth: 1.71429,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.653 54.9102H177.334H160.387V55.61V55.9585H175.667L159.789 85.0887H165.108H182.054V84.3888V84.0382H166.775L182.653 54.9102Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.531 81.3162C189.043 81.3162 187.74 81.0518 186.624 80.5223C185.531 79.9928 184.645 79.2708 183.966 78.3607C183.31 77.4507 182.873 76.4215 182.653 75.277H184.129C184.459 76.7408 185.169 77.9061 186.264 78.7741C187.38 79.6222 188.803 80.0455 190.532 80.0455C191.845 80.0455 192.961 79.7605 193.88 79.1875C194.799 78.5938 195.499 77.8098 195.979 76.8356C196.482 75.8407 196.735 74.7282 196.735 73.4988C196.735 72.2695 196.482 71.1349 195.979 70.1599C195.476 69.1636 194.754 68.391 193.814 67.8401C192.894 67.2885 191.822 67.0141 190.598 67.0141C189.109 67.0141 187.85 67.3206 186.821 67.9342C185.794 68.55 185.016 69.366 184.492 70.3823H183.113L185.016 58.6836H196.57V59.955H186.199L184.756 68.2528C185.302 67.5529 186.079 66.9593 187.085 66.4718C188.114 65.9843 189.306 65.742 190.662 65.742C191.712 65.742 192.687 65.9223 193.584 66.2815C194.503 66.6421 195.302 67.1716 195.979 67.8715C196.679 68.5493 197.228 69.3653 197.621 70.3181C198.015 71.2503 198.211 72.3115 198.211 73.4981C198.211 74.493 198.048 75.4673 197.718 76.4215C197.414 77.3537 196.932 78.1918 196.275 78.9323C195.64 79.6543 194.843 80.2358 193.88 80.6812C192.938 81.106 191.822 81.317 190.532 81.317L190.531 81.3162Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2910_4691",
    x1: 140,
    y1: 0,
    x2: 140,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00183A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2910_4691",
    x1: 140,
    y1: 0,
    x2: 140,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00265A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeePartner);
export default __webpack_public_path__ + "static/media/zeePartner.c417b27e5241e7b149033063ef582249.svg";
export { ForwardRef as ReactComponent };